<template>
  <div class="container">
    <h4 class="title is-4">Future Monthly Income or Expense</h4>
    <p>
      Use this section for future income or expenses you expect to incur. The
      item shown suggests you have a side hustle that you think will earn 4k per
      month but it might take 5 months to get to that income level.
    </p>
    <FutureItem
      v-bind:future_items="future_items"
      v-bind:total_future="total_future"
      @del-fut="$emit('del-fut', index)"
    />
  </div>
</template>

<script>
import FutureItem from "./FutureItem.vue";

export default {
  name: "FutureIncome",
  components: {
    FutureItem,
  },
  props: {
    future_items: Array,
    total_future: Number,
  },
  data() {
    return {};
  },
};
</script>